var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 27H9V33.1215L16.6515 27H24C25.6545 27 27 25.6545 27 24V12C27 10.3455 25.6545 9 24 9H6C4.3455 9 3 10.3455 3 12V24C3 25.6545 4.3455 27 6 27Z",
    fill: "#0073FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30 3H12C10.3455 3 9 4.3455 9 6H27C28.6545 6 30 7.3455 30 9V21C31.6545 21 33 19.6545 33 18V6C33 4.3455 31.6545 3 30 3Z",
    fill: "#0073FF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.7b7f6178418d026d7b64256128a6bba2.svg";
export { ForwardRef as ReactComponent };